import React from 'react'
import './FouroFour.css'

function FouroFour() {
  return (
    <div className='fourofour'>
      <h1 className='hh1'>404</h1>
      <h2 className='hh2'>ፎረፎር</h2>
    </div>
  )
}

export default FouroFour